import { Vector3 } from 'three';
import { calculateCartographicQuaternion, toCartographic } from '../../../Utils';
/**
 * Roughly place the object in the world to set its position.
 *
 * The user can then finely adjust it using the widget.
 */
export class PointTool {
    constructor(model, pointer, renderer, gestures) {
        Object.defineProperty(this, "target", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "pointer", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "renderer", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "gestures", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "running", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        this.target = model;
        this.pointer = pointer;
        this.renderer = renderer;
        this.gestures = gestures;
        this.running = false;
    }
    /**
     * Start the tool.
     *
     * @param onTransform
     */
    start(onTransform) {
        this.stop();
        this.running = true;
        this.renderer.getWorld().addObject(this.pointer);
        // Update the position of the placement on hover
        this.gestures.register('hover', gesture => {
            const pick = this.renderer.pickScreenWorldSpaceSnapping(gesture.position);
            const position = new Vector3(pick.position.x, pick.position.y, pick.position.z);
            this.pointer.setPositionECEF(position);
        });
        // Update the position of the placement on zoom
        this.gestures.register('zoom', gesture => {
            const pick = this.renderer.pickScreenWorldSpaceSnapping(gesture.position);
            const position = new Vector3(pick.position.x, pick.position.y, pick.position.z);
            this.pointer.setPositionECEF(position);
        });
        // Submit the new position and update the model
        this.gestures.register('release', gesture => {
            const pick = this.renderer.pickScreenWorldSpace(gesture.position);
            const position = new Vector3(pick.position.x, pick.position.y, pick.position.z);
            const rotation = calculateCartographicQuaternion(toCartographic(position));
            this.target.setPosition(position);
            this.target.setRotation(rotation);
            onTransform(position, rotation);
        });
    }
    /**
     * Stop the tool.
     */
    stop() {
        this.running = false;
        this.renderer.getWorld().removeObject(this.pointer);
        this.gestures.unregisterAll();
    }
    /**
     * Check if the tool is active.
     *
     * @returns
     */
    isActive() {
        return this.running;
    }
    /**
     * Get the target model.
     */
    getTarget() {
        return this.target;
    }
}
